import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@univacity/shared/types';
@Pipe({
  name: 'userType',
  standalone: false,
})
export class UserTypePipe implements PipeTransform {
  transform(user?: string | User): User {
    return user as User;
  }
}
